/**
 * Entry to the return portal without an account: order number and e-mail.
 *
 * Markup contract (acl-order module, retourenportal.html.twig):
 *   <form id="returnPortalForm" x-data="validatedForm" @submit="submit($event)" …>
 *     <div x-data="returnPortalForm">
 *       <div id="returnPortalError" x-show="error"><p x-text="error"></p></div>
 *
 * The answer is the customer's personal url at the portal, which replaces this page.
 */
import { returnPortalUrl } from './aclOrder.js';

document.addEventListener('alpine:init', () => {
    Alpine.data('returnPortalForm', () => ({
        error: '',

        init() {
            this.addBeforeSubmit(() => this.open());
        },

        async open() {
            this.error = '';

            try {
                window.location.href = await returnPortalUrl({
                    orderNumber: this.$refs.orderNumber.value.trim(),
                    email: this.$refs.email.value.trim(),
                });
            } catch (failure) {
                this.error = failure.message;
            }

            return false;
        },
    }));
});
